import classNames from 'classnames'

import * as styles from './Box.module.css'

function Box({
  children,
  className,
  isFullScreen,
  ref,
  size = null,
  ...divProps
}) {
  const boxClassName = classNames(
    styles.box,
    { [styles.fullScreen]: isFullScreen },
    size ? styles[`${size}Size`] : null,
    className
  )

  return (
    <div {...divProps} className={boxClassName} ref={ref}>
      {children}
    </div>
  )
}

export default Box
